/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import PropTypes from 'prop-types';

const listBoxTypes = ['default', 'inline'];
const listBoxSizes = ['sm', 'md', 'lg'];
const ListBoxType = PropTypes.oneOf(listBoxTypes);
const ListBoxSize = PropTypes.oneOf(listBoxSizes);

export { ListBoxSize, ListBoxType };
